module.exports = __webpack_public_path__ + "static/fipclamb-673cded31b1e91424cb09159c5148fde.jpeg";